const Nav = {
    list:'list',
    product:'Product Center',
    about_shinetech:'About Us',
    news:'News',
    collaborate:'Collaborate',
    join_us:'Join Us',
    contact_us:'Contact Us'
  }
  const Contactus = {
    formTitle:"協業のご相談",
    Form:{
      name:"氏名",
      namePlaceholder:"お名前を入力してください",
      nameMaxLength:"50文字以内で入力してください",
      phone:"電話",
      phonePlaceholder:"電話番号を入力してください",
      phoneMaxLength:"電話番号は20文字以内で入力してください",
      email:"メール",
      emailPlaceholder:"メールアドレスを入力してください",
      emailMaxLength:"100文字以内で入力してください",
      company:"会社",
      companyPlaceholder:"会社名を入力してください",
      companyMaxLength:"100文字以内で入力してください",
      content:"メッセージ",
      contentPlaceholder:"メッセージ内容を入力してください",
      contentMaxLength:"500文字以内で入力してください",
      submit:"送信",
      phoneError:"電話番号の形式が正しくありません",
      submitFrequent:"送信頻度が高すぎます。1分後にもう一度お試しください",
      submitConfirmation:"内容にお間違いないかご確認ください。フォームを送信します。",
      submitCancel:"キャンセル",
      submitTitle:"提示",
    },
  }

  const AiChat = {
    buttonIcon:"bot_button_ja.png",
    buttonText:"AIサポート",
    title:"盛泰スマートカスタマーサービス",
    content:"こんにちは、私はDeepSeekに基づくAIカスタマーサービスです。盛泰製品に関する疑問にお答えできることを楽しみにしていますね~",
    loading:"少々お待ちください...",
    placeholder:"ご相談された問題を入力してください",
    send:"送信",

    customerForm:{
      productLabel:"ご用件",
      productPlaceholder:"コミュニケーションの意向を選択してください",
      phoneLabel:"ご連絡先",
      phonePlaceholder:"連絡先を入力してください",
      nameLabel:"ご氏名",
      namePlaceholder:"お名前を入力してください",
    },
  }
    // 按功能模块导出
    export default {
      Nav,
      AiChat,
      Contactus
    }